// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2HLhp","signatureBlock":"Footer_signatureBlock__2uT16","signature":"Footer_signature__2omWU"};